<template>

    <div>
        <div class="slide mb-5 mt-5">
            <div class="bg-img">
                <div class="slide-content">
                    <h2 class="slide-header">{{ 'order invoices' }}</h2>
                    <div>
                        <h5 class="slide-h5">{{ $t('message.home') }}</h5>
                        <b-icon :icon="isRTL ? 'chevron-double-left' : 'chevron-double-right'"
                            class="icon-slider"></b-icon>
                        <h5 class="slide-h5">{{ 'order invoices' }}</h5>
                    </div>
                </div>
            </div>
        </div>


        <div class="container mb-5">
            <h4 class="item-details-header mt-4 mb-4"> order details </h4>
            <div class="item-history">
                <b-row class="mb-3">
                    <b-col cols="3">
                        <b-form-group label="Name">
                            <b-form-input style="border-radius: 10px;" v-model="this.order.name"
                                disabled></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col cols="3">
                        <b-form-group label="Phone">
                            <b-form-input style="border-radius: 10px;" v-model="this.order.phone"
                                disabled></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col cols="3">
                        <b-form-group label="number of inoices">
                            <b-form-input style="border-radius: 10px;" v-model="this.order.supplyOrderCount"
                                disabled></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col cols="3">
                        <b-form-group label="created date">
                            <b-form-input style="border-radius: 10px;" v-model="this.order.created_date"
                                disabled></b-form-input>
                        </b-form-group>
                    </b-col>
                </b-row>

            </div>

            <!-- زر إضافة فاتورة -->
            <div class="text-right mt-4 mb-4">
                <b-button variant="primary" @click="showModal = true">
                    Add New Invoice
                </b-button>
            </div>

            <!-- الكروت الخاصة بالفواتير -->
            <b-row>
                <b-col v-for="(invoice, index) in invoices" :key="index" cols="12" md="6" lg="4" class="mb-4">
                    <div class="invoice-card">
                        <div class="invoice-header">
                            <h5>
                                <b-icon icon="file-earmark-text" variant="primary" class="mr-2" />
                                {{ invoice.supplier_name }}
                            </h5>
                            <b-badge :variant="getStatusVariant(invoice.status)">
                                {{ getStatusText(invoice.status) }}
                            </b-badge>
                        </div>

                        <div class="invoice-body">
                            <!-- <p>
                                <b-icon icon="person-fill" class="mr-2" />
                                <strong>Supplier:</strong> {{ invoice.supplier_name }}
                            </p> -->
                            <p>
                                <b-icon icon="telephone-fill" class="mr-2" />
                                <strong>Phone:</strong> {{ invoice.supplier_phone }}
                            </p>
                            <p>
                                <b-icon icon="calendar-event-fill" class="mr-2" />
                                <strong>Created:</strong> {{ invoice.created_date }}
                            </p>
                            <p>
                                <b-icon icon="file-earmark-text-fill" class="mr-2" />
                                <strong>Items count:</strong> {{ invoice.itemsCount }}
                            </p>
                            <p>
                                <b-icon icon="currency-dollar" class="mr-2" />
                                <strong>Total with VAT:</strong> {{ invoice.totalPriceWithVat }}
                            </p>
                            <p>
                                <b-icon icon="currency-dollar" class="mr-2" />
                                <strong>Total without VAT:</strong> {{ invoice.totalPriceWithoutVat }}
                            </p>
                        </div>

                        <div class="invoice-footer">
                            <small class="text-muted">
                                <b-icon icon="hash" class="mr-1" />
                                Inovice ID: {{ invoice.id }}
                            </small>
                        </div>
                    </div>
                </b-col>
            </b-row>



        </div>

        <!-- Modal إنشاء فاتورة جديدة -->
        <b-modal scrollable size="xl" v-model="showModal" class="custom-modal" title="Add New Invoice"
            @ok="createInvoice" :ok-disabled="!isFormValid">
            <b-form @submit.stop.prevent="createInvoice">
                <b-form-group label="Suplier Name">
                    <b-form-input v-model="form.suplier_name" required></b-form-input>
                </b-form-group>

                <b-form-group label="Suplier Phone">
                    <b-form-input v-model="form.suplier_phone" required></b-form-input>
                </b-form-group>

                <b-form-group label="Select Items">
                    <v-select v-model="selectedItems" label="desc_ar" :filterable="false" :options="items"
                        :multiple="true" @search="searchItems" placeholder="Type to search items..." />
                </b-form-group>

                <div v-if="selectedItems.length > 0" class="d-flex justify-content-end mb-3">
                    <b-button variant="outline-success" size="sm" class="mr-2" @click="openAll">
                        <b-icon icon="chevron-down" class="mr-1" /> فتح الكل
                    </b-button>

                    <b-button variant="outline-secondary" size="sm" @click="closeAll">
                        <b-icon icon="chevron-up" class="mr-1" /> إغلاق الكل
                    </b-button>
                </div>

                <b-card v-for="(item, index) in selectedItems" :key="item.id" class="mb-3 shadow-sm" bg-variant="light"
                    border-variant="light" header-tag="header"
                    header-class="d-flex justify-content-between align-items-center">
                    <!-- رأس البطاقة -->
                    <div class="d-flex align-items-center justify-content-between">
                        <div>
                            <b-icon icon="box-seam" class="mr-2 text-primary" />
                            <strong>{{ item.desc_ar }}</strong>
                        </div>


                        <!-- زر الحذف -->
                        <div>
                            <b-button size="sm mr-2" variant="outline-danger" @click="removeItem(item)">
                                <b-icon icon="x" />
                            </b-button>

                            <!-- زر فتح/إغلاق -->
                            <b-button @click="toggleItemCollapse(item.id)" variant="outline-primary" size="sm" class="">
                                <b-icon icon="chevron-down" /> Toggle Details
                            </b-button>
                        </div>
                    </div>


                    <!-- Collapse -->
                    <b-collapse :id="'collapse-' + item.id" :visible="isOpen(item.id)" class="mt-3">
                        <b-row class="mb-2">
                            <b-col md="4" lg="2">
                                <b-form-group label="item code">
                                    <b-form-input v-model="item.code" disabled />
                                </b-form-group>
                            </b-col>
                            <b-col md="4" lg="2">
                                <b-form-group label="Item Barcode">
                                    <b-form-input v-model="item.bar_code" disabled />
                                </b-form-group>
                            </b-col>
                            <b-col md="4" lg="2">
                                <b-form-group label="Item Manufacturer">
                                    <b-form-input v-model="item.manufacture" disabled />
                                </b-form-group>
                            </b-col>
                            <b-col md="4" lg="2">
                                <b-form-group label="Item Model">
                                    <b-form-input v-model="item.model_number" disabled />
                                </b-form-group>
                            </b-col>
                            <b-col md="4" lg="2">
                                <b-form-group label=" Item UOM">
                                    <b-form-input v-model="item.uom" disabled />
                                </b-form-group>
                            </b-col>
                            <b-col md="4" lg="2">
                                <b-form-group label="Storage Conditions">
                                    <b-form-input v-model="item.storage_condition" disabled />
                                </b-form-group>
                            </b-col>
                            <b-col md="4" lg="2">
                                <b-form-group label="Item Storage">
                                    <b-form-input v-model="item.release_item" disabled />
                                </b-form-group>
                            </b-col>
                            <b-col md="4" lg="2">
                                <b-form-group label="Quantity">
                                    <b-form-input v-model="item.quantity" type="number" required />
                                </b-form-group>
                            </b-col>

                            <b-col md="4" lg="2">
                                <b-form-group label="Quality Control">
                                    <b-form-checkbox v-model="item.qualityControl">
                                    Passed
                                    </b-form-checkbox>
                                </b-form-group>
                            </b-col>


                            <b-col md="4" lg="2">
                                <b-form-group label="Expected Delivery">
                                    <b-form-datepicker v-model="item.deliveryDate" required />
                                </b-form-group>
                            </b-col>

                            <b-col md="4" lg="2">
                                <b-form-group label="Price (No VAT)">
                                    <b-form-input v-model.number="item.priceNoVAT" type="number"
                                        @input="updateTotalWithVAT(item)" required />
                                </b-form-group>
                            </b-col>

                            <b-col md="4" lg="2">
                                <b-form-group label="VAT Amount">
                                    <b-form-input v-model.number="item.vatAmount" type="number"
                                        @input="updateTotalWithVAT(item)" required />
                                </b-form-group>
                            </b-col>

                            <b-col md="4" lg="2">
                                <b-form-group label="Total With VAT">
                                    <b-form-input v-model="item.totalWithVAT" type="number" readonly class="bg-light" />
                                </b-form-group>
                            </b-col>


                            <b-col md="4" lg="2">
                                <b-form-group label="Country of Origin">
                                    <b-form-input v-model="item.countryOfOrigin" required />
                                </b-form-group>
                            </b-col>

                            <!-- <b-col md="4" lg="2">
                                <b-form-group label=" Serial Number or Batch Number">
                                    <b-form-input v-model="item.serialNumber" required />
                                </b-form-group>
                            </b-col> -->
                            
                            <!-- <b-col md="4" lg="2">
                                <b-form-group label="Expiry Date">
                                    <b-form-datepicker v-model="item.expiryDate" />
                                </b-form-group>
                            </b-col> -->

                            <!-- <b-col md="4" lg="2">
                                <b-form-group label="Warranty Info">
                                    <b-form-input v-model="item.warranty" />
                                </b-form-group>
                            </b-col> -->

                            <!-- <b-col md="4" lg="2">
                                <b-form-group label="Condition">
                                    <b-form-select v-model="item.condition" :options="['New', 'Used']" />
                                </b-form-group>
                            </b-col> -->

                            <!-- <b-col md="4" lg="2">
                                <b-form-group label="Received Qty">
                                    <b-form-select v-model="item.receivedQty" :options="['All', 'Part']" />
                                </b-form-group>
                            </b-col> -->
                        </b-row>

                        <!-- <b-row class="mb-2">


                            <b-col md="6">
                                <b-form-group label="Invoice Numbers">
                                    <b-form-tags v-model="item.invoiceNumbers" placeholder="Enter invoice numbers..." />
                                </b-form-group>
                            </b-col>

                            <b-col md="6">
                                <b-form-group label="Receipt Numbers">
                                    <b-form-tags v-model="item.receiptNumbers" placeholder="Enter receipt numbers..." />
                                </b-form-group>
                            </b-col>
                        </b-row> -->
                    </b-collapse>


                </b-card>




            </b-form>
        </b-modal>

    </div>

</template>

<script>
import axiosInstance from '../axios-config';
import { mapGetters } from 'vuex'
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';

export default {
    name: 'ShowInvoices',
    components: {
        vSelect
    },
    data() {
        return {
            invoices: [],
            showModal: false,
            items: [],
            selectedItems: [],
            openCollapseIds: [], // IDs of currently opened collapses
            form: {
                suplier_name: '',
                suplier_phone: '',
            },
        };
    },
    computed: {
        ...mapGetters(['getUser']),
        company_id() {
            return this.getUser; // استخدام الـ getter لجلب بيانات المستخدم
        },
        isRTL() {
            return this.$i18n.locale === 'ar';
        },
        order() {
            return this.$store.state.order;  // الوصول إلى الـ order من Vuex
        },
        isFormValid() {
            if (!this.form.suplier_name || !this.form.suplier_phone) return false;
            if (this.selectedItems.length === 0) return false;

            return this.selectedItems.every(item =>
                item.quantity &&
                item.qualityControl &&
                item.deliveryDate &&
                item.priceNoVAT &&
                item.vatAmount &&
                item.totalWithVAT &&
                item.countryOfOrigin
                // item.serialNumber &&
                // item.expiryDate &&
                // item.condition &&
                // item.receivedQty
                // item.invoiceNumbers?.length > 0 &&
                // item.receiptNumbers?.length > 0
            );
        }
    },
    methods: {

        updateTotalWithVAT(item) {
            const price = parseFloat(item.priceNoVAT) || 0;
            const vat = parseFloat(item.vatAmount) || 0;
            item.totalWithVAT = (price + vat).toFixed(2);
        },

        removeItem(item) {
            this.selectedItems = this.selectedItems.filter(i => i.id !== item.id);
        },

        isOpen(id) {
            return this.openCollapseIds.includes(id);
        },
        setOpen(id, value) {
            if (value) {
                if (!this.openCollapseIds.includes(id)) this.openCollapseIds.push(id);
            } else {
                this.openCollapseIds = this.openCollapseIds.filter(i => i !== id);
            }
        },
        toggleItemCollapse(id) {
            this.setOpen(id, !this.isOpen(id));
        },
        openAll() {
            this.openCollapseIds = this.selectedItems.map(i => i.id);
        },
        closeAll() {
            this.openCollapseIds = [];
        },

        async fetchInvoices() {
            try {
                const response = await axiosInstance.get(`store/select_supply_orders.php`, {
                    params: {
                        order_id: this.order.id,
                        status: -1,
                    },
                });

                if (response.data.status === "true") {
                    this.invoices = response.data.output;
                }
            } catch (err) {
                console.error("Error fetching invoices", err);
            }
        },

        getStatusText(status) {
            switch (status) {
                case "0": return "Pending";
                case "1": return "Added to store";
                case "2": return "Rejected";
                default: return "Unknown";
            }
        },

        getStatusVariant(status) {
            switch (status) {
                case "0": return "warning";
                case "1": return "success";
                case "2": return "danger";
                default: return "secondary";
            }
        },

        async searchItems(search_key) {
            try {
                const formData = new FormData();
                formData.append('company_id', this.company_id.company_id);
                formData.append('search_key', search_key);

                const response = await axiosInstance.post('store/search_items.php', formData);
                this.items = response.data.output; // تأكد إن الـ API يرجع { items: [...] }
            } catch (err) {
                console.error('Search failed', err);
            }
        },

        async createInvoice() {
            try {
                const queryParams = new URLSearchParams({
                    order_id: this.order.id,
                    suplier_name: this.form.suplier_name,
                    suplier_phone: this.form.suplier_phone,
                    by_user_id: this.company_id.id,
                }).toString();

                const body = this.selectedItems.map(item => ({
                    itemId: item.id,
                    quantity: item.quantity,
                    qualityControl: item.qualityControl ? 1 : 0,
                    expexted_delivery_date: item.deliveryDate,
                    item_price_without_vat: item.priceNoVAT,
                    item_vat: item.vatAmount,
                    // line_total_price: item.totalWithVAT,
                    item_serial_number: null,
                    item_expiry_date: null,
                    item_warranty: null,
                    // item_condition: item.condition === 'New' ? 1 : 2,
                    item_condition: null,
                    // item_received_quantity: item.receivedQty === 'All' ? 1 : 2,
                    item_received_quantity: null,
                    // invoice_number: item.invoiceNumbers?.join(','),
                    // receipt_number: item.receiptNumbers?.join(','),
                    invoice_number: null,
                    receipt_number: null,
                }));

                const response = await axiosInstance.post(
                    `store/insert_supply_order.php?${queryParams}`,
                    body,
                    {
                        headers: {
                            'Content-Type': 'application/json',
                        }
                    }
                );

                if (response.data.status === "true") {
                    this.$izitoast.success({
                        title: "Success",
                        message: "Invoice created successfully! ✅",
                        position: "bottomLeft",
                        timeout: 5000,
                    });
                    this.showModal = false;
                    this.resetForm(); // 🧹 تصفير البيانات هنا
                } else {
                    throw new Error('API returned failure.');
                }
            } catch (error) {
                console.error(error);

                this.$izitoast.error({
                    title: 'Error',
                    message: 'Failed to insert supply order.',
                    position: 'bottomLeft',
                    timeout: 5000,
                });
            }
        },
        resetForm() {
            this.form = {
            suplier_name: '',
            suplier_phone: ''
            };
            this.selectedItems = [];
        },


    },
    mounted() {
        console.log(this.order);  // سيتم طباعة الـ order هنا
        this.fetchInvoices();
    },
};




</script>

<style scoped>
.item-details-header {
    font-size: 22px;
    font-weight: 600;
    color: #2274BD;
}

.item-history {
    border: 1px solid #ddd;
    border-radius: 10px;
    padding: 20px;
    /* margin: 20px; */
    margin-bottom: 90px;
    box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 4px;
}

/* .invoice-card {
    background: linear-gradient(135deg, #e9f4ff, #f8fbff);
    border: 1px solid #d4ecff;
    border-radius: 20px;
    padding: 20px;
    box-shadow: 0 6px 15px rgba(0, 123, 255, 0.1);
    transition: transform 0.3s ease, box-shadow 0.3s ease;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;
}

.invoice-card:hover {
    transform: translateY(-5px);
    box-shadow: 0 10px 20px rgba(0, 123, 255, 0.2);
}

.invoice-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
}

.invoice-body p {
    margin-bottom: 6px;
    font-size: 14px;
    color: #333;
}

.invoice-footer {
    margin-top: 10px;
    text-align: right;
    font-size: 13px;
    color: #666;
} */

.invoice-card {
    background: linear-gradient(135deg, #f9fcff, #eaf4ff);
    border: none;
    border-left: 6px solid #0d6efd;
    border-radius: 18px;
    padding: 25px;
    box-shadow: 0 6px 20px rgba(13, 110, 253, 0.1);
    transition: transform 0.3s ease, box-shadow 0.3s ease;
    height: 100%;
}

.invoice-card:hover {
    transform: translateY(-6px);
    box-shadow: 0 12px 30px rgba(13, 110, 253, 0.15);
}

.invoice-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 15px;
}

.invoice-header h5 {
    font-size: 1.3rem;
    font-weight: 700;
    color: #0d6efd;
    display: flex;
    align-items: center;
}

.invoice-body {
    font-size: 1.05rem;
    color: #333;
    margin-bottom: 15px;
}

.invoice-body p {
    margin-bottom: 10px;
    display: flex;
    align-items: center;
}

.invoice-body b-icon {
    font-size: 1.2rem;
    margin-right: 10px;
    color: #0d6efd;
}

.invoice-footer {
    text-align: right;
    font-size: 0.95rem;
    color: #666;
}

.custom-modal {
    border-radius: 10px !important;
    padding: 15px;
    /* background: #f8f9fa; */
}
</style>